export default __webpack_public_path__ + "static/techrise-p33-logo-gray-5795ea631d4dcecf29b5508ad84caa0c.png";